import { InputOTP } from 'antd-input-otp';
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Config from "../../../Config";

import "./mrtt_client_screen.css";
import GeneralBloc from "../../../bloc/general_bloc";
import ClientBloc from "../../../bloc/client_bloc";
import AppModal from "../../component/app_modal/app_modal";
import AppMobileLoading from "../../dialog/app_mobile_loading";

class ClientVerification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            idNo: null,
            qrExpired: true,
            otpProcId: null,
            mobileNo: '0128954758',
            email: 'abc@mail.com',
            currentSendDestination: '',
            otpChannel: 'sms',
        };
    }

    componentDidMount() {
        this.handleSendOTP();
    }


    getProposalId() {
        return this.props.match.params.itemId;
    }

    async handleSendOTP() {
        this.setState({ loading: true });
        let sendOTP = await ClientBloc.requestOTP(this.getProposalId(), this.state.otpProcId);
        console.log('senddddd', sendOTP);
        if (sendOTP.success) {
            this.setState({
                otpProcId: sendOTP.data?.otpProcId,
                currentSendDestination: sendOTP.data.destination
            });
        } else {
            this.setState({
                title: 'Notification',
                message: sendOTP.message,
                isOpen: true
            })
        }
        this.setState({ loading: false });
    }

    async handleSubmitOTP(val) {
        //submit to api
        let otpInput = '';
        val.forEach(element => {
            otpInput = otpInput + element
        });
        let submitResult = await ClientBloc.verifytOTP(this.state.otpProcId, otpInput);
        console.log('otp submit', submitResult)
        if (submitResult.success) {
            await sessionStorage.setItem('dataClient', JSON.stringify(submitResult.data));
            window.location.replace(`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_proposal}/${this.getProposalId()}`)
        } else {
            this.setState({ error: true });
        }

    }

    showMessageModal = () => {
        return (
            <AppModal
                open={this.state.isOpen}
                handleModalClose={() => this.setState({ isOpen: false })}
                // width={'50%'}
                title={this.state.title}
                subtitle={this.state.message}
                positiveButtonText={'Close'}
                handlePositivePress={() => this.setState({ isOpen: false })}
                closable={false}
            />
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%" }}>
                <AppMobileLoading isLoading={true} />
            </div>
        );
    }

    render() {
        return (
            <div className="client_container" style={{ height: '100%' }}>
                {this.state.loading && this.loadingContent()}
                <div className="mobile_container d-fkex justify-content-center" style={{ height: window.innerHeight, overflowY: 'scroll' }}>

                    <div className="client_header">
                        OTP Verification
                    </div>
                    <div className="d-flex justify-content-center p-4 row w-100 m-0">
                        <img
                            src={
                                GeneralBloc.getAssetsContextPath() +
                                `/assets/images/Illustration/passwordRecovery.png`
                            }
                            alt="Documents"
                            className=""
                            style={{ width: 175, height: 154 }}
                        />
                        <div className="client_instruction_text mt-4" style={{ fontSize: 16, fontWeight: 600 }}>
                            This is to verify your identity before reviewing the proposal
                            <div className="mt-2" style={{ fontSize: 14, fontWeight: 400 }}>
                                Please enter the OTP sent to
                                <span style={{ color: '#EE7623' }}>
                                    {' ' + this.state.currentSendDestination}
                                </span>
                            </div>
                        </div>
                        <div className="mt-4">
                            <InputOTP
                                className='otp_container otp_input_container'
                                autoSubmit={(e) => this.handleSubmitOTP(e)}
                                inputType="numeric"
                                inputStyle={{ border: this.state.error ? '1px solid #FC5A5A' : '' }}
                            />
                        </div>
                        <div className="d-flex justify-content-between mt-2">
                            <div className="grey_text">Didn{'\'t'} receive OTP?</div>
                            <div className="resend_text" onClick={() => this.handleSendOTP()}>Resend OTP</div>
                        </div>

                    </div>
                    {this.showMessageModal()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
});

export default withRouter(connect(mapStateToProps)(ClientVerification));
